<template>
  <div class="widget">
    <div class="widget-heading align-items-center">
      <h2>{{ $t("registration.contacts") }}</h2>
    </div>
    <div class="widget-content" v-if="displayForm">
      <FormComponent :models="models" :hideSubmit="true" />
      <SubmitTypeComponent :hideCancel="true" @submitForm="$emit('submit')" />
      <BlockLoader :loading="loading" />
    </div>
    <div v-else class="widget-content">
      <TrainingContactBlockListComponent :list="contactList" />
    </div>
  </div>
</template>

<script>
import FormComponent from "@/components/FormComponent.vue";
import SubmitTypeComponent from "@/components/form/SubmitTypeComponent.vue";
import BlockLoader from "@/components/blocks/BlockLoader.vue";
import { accessConstante } from "@/constantes/access";
import { accessManager } from "@/services/security/access-manager";
import TrainingContactBlockListComponent from "@/components/training/TrainingContactBlockListComponent.vue";
import { useUserStore } from "@/store/user/user";
import { mapState } from "pinia";

export default {
  name: "TrainingContactBlock",
  components: { TrainingContactBlockListComponent, BlockLoader, SubmitTypeComponent, FormComponent },
  props: {
    models: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["submit"],
  computed: {
    ...mapState(useUserStore, ["permissions"]),
    contactList() {
      return Object.values(this.models).map(({ vars }) => ({
        label: vars.label,
        list: vars.data.map((item) => {
          const choice = vars.choices.find((c) => c.data.id === item.id);
          return { label: choice?.label, data: choice?.data };
        }),
      }));
    },
    displayForm() {
      const permissions = this.permissions;
      return !!(
        permissions &&
        accessManager.isAvailableForUser(null, accessConstante.STUDEA_MANAGER_TRAINING_CONTACT, accessConstante.ALL)
      );
    },
  },
};
</script>
